module.exports = __webpack_public_path__ + "static/media/b-triple.7600c240.svg";